export default {

  state: {
    speedLow: null,
    speedHigh: null,
    county: null,
    locations: [],
  },

  mutations: {

    SET_SPEED_LOW(state, payload) {
      state.speedLow = payload;
    },

    SET_SPEED_HIGH(state, payload) {
      state.speedHigh = payload;
    },

    SET_COUNTY(state, payload) {
      state.county = payload;
    },

    SET_LOCATIONS(state, payload) {
      state.locations = payload;
    },

  },

  actions: {

    // setSelection({ commit, state }, selection) {
    //   const newSelections = {
    //     ...state.selections,
    //   };
    //   newSelections[selection.key] = selection.value;
    //   commit('SET_SELECTIONS', newSelections);
    // },

  },

};
